/* Shared number/duration formatters for the admin dashboard sections. */
/* Extracted from pages/Admin.tsx (NAI-207) so the section components can reuse */
/* them without duplicating logic. */

export function formatDuration(totalSec: number): string {
  if (totalSec < 60) return `${Math.round(totalSec)} s`;
  const m = Math.floor(totalSec / 60);
  const s = Math.round(totalSec - m * 60);
  if (m < 60) return s === 0 ? `${m} min` : `${m} min ${s} s`;
  const h = Math.floor(m / 60);
  const rm = m - h * 60;
  return rm === 0 ? `${h} h` : `${h} h ${rm} min`;
}

/* 1234 → "1.2k", 1234567 → "1.2M". Keeps the dashboard scannable when */
/* token counts climb past 5 digits. */
export function compactNumber(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1_000_000) return `${(n / 1000).toFixed(n < 10_000 ? 1 : 0)}k`;
  return `${(n / 1_000_000).toFixed(n < 10_000_000 ? 1 : 0)}M`;
}
